<template lang="pug">
  .materials-tab
    .tab-item(v-for="item in items", :key="item.id", :class="{active: isSelected(item)}", @click="onTabClick(item)")
      .tab-title {{$t(item.title)}}
      .tab-indicator
</template>
<script>
export default {
  name: 'MaterialsTab',
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selectedValue: null,
      items: [
        {
          id: 'carcass',
          title: 'MATERIALS_TAB_CARCASS'
        },
        {
          id: 'external',
          title: 'MATERIALS_TAB_EXT'
        },
        {
          id: 'roof',
          title: 'MATERIALS_TAB_ROOF'
        },
      ]
    }
  },

  mounted() {
    if (!this.value) {
      this.selectedValue = this.items[0]
    } else {
      this.selectedValue = this.value
    }
  },

  watch: {
    selectedValue(val) {
      if (this.value !== val) this.$emit('input', this.selectedValue)
    }
  },

  methods: {
    isSelected(item) {
      return this.selectedValue === item
    },

    onTabClick(item) {
      this.selectedValue = item
    }
  }
}
</script>
